import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import "../VehiculeForm.css";

const StepOneOccasion = ({ sendData, isActive, onNext, commonData, handleSave }) => {

    const [formData, setFormData] = useState({
        // MOTIF DE LA DEMANDE (unique to occasion)
        occ_ra_1: null, // "Sélectionner la raison correspondante" 1: Certificat 2: Duplicata 3: Correction 4: Changement de domicile 5: Changement d'etat civil ou matrimonial 6: Changement de caracteristiques techniques 7: Carte Grise
        
        // VÉHICULE - Fields specific to occasion
        occ_veh_27: null, // "N° d'immatriculation du véhicule (A)"
        occ_veh_27_1: null, // "Date d'achat, le cas échéant " JJ
        occ_veh_27_2: null, // "Date d'achat, le cas échéant " MM
        occ_veh_27_3: null, // "Date d'achat, le cas échéant " AAAA
        occ_veh_28_1: null, // "Date de certificat actuel (I)" JJ
        occ_veh_28_2: null, // "Date de certificat actuel (I)" MM
        occ_veh_28_3: null, // "Date de certificat actuel (I)" AAAA
        occ_veh_29_1: null, // "Date de 1ère immatriculation (B) " JJ
        occ_veh_29_2: null, // "Date de 1ère immatriculation (B) " MM
        occ_veh_29_3: null, // "Date de 1ère immatriculation (B) " AAAA
        occ_veh_0: null, // "N° de formule du certificat d'immatriculation"
        
        // VÉHICULE - Common fields with same IDs as neuf
        veh_1: null, // "Marque (D.1)" - same in both forms
        veh_2: null, // "Type, variante, version (D.2)" - same in both forms
        veh_4: null, // "Dénomination commerciale (D.3)" - same in both forms
        veh_6: null, // "N° identification du véhicule (E)" - same in both forms
        veh_13: null, // "Genre national (J.1)" - same in both forms
        veh_19: null, // "Puissance administrative nationale (P.6)" - same in both forms
        
        // Fields specific to occasion
        occ_veh_30: null, // "N° d'exploitation agricole, le cas échéant "
        occ_veh_31: null, // "Kilométrage inscrit au compteur du véhicule"
        occ_veh_32: null, // "Présence du certificat d'immatriculation" 0: non 1: oui
        
        // Fields conditionally shown if occ_veh_32 is "oui"
        occ_veh_32_1: null, // "Quel est le format de votre n° d'immatriculation ?" 1: AB-123-CD 2: 123-AB-45
        
        // Fields conditionally shown if occ_veh_32 is "non"
        occ_veh_32_2: null, // "Motif d'absence de certificat d'immatriculation (100 caracteres)"
        
        // NUANCES ET COULEUR - same in both forms
        veh_33: null, // 0: clair 1: foncé
        veh_34: null, // 0: Noir 1: Marron 2: Bleu 3:Rouge 4:Beige 5:Orange 6:Gris 7:Jaune 8:Vert 9:Blanc
    });

    useEffect(() => {
        if (commonData?.stepOneData && Object.keys(commonData.stepOneData).length > 0) {
            setFormData(prevState => ({
                ...prevState,
                ...commonData.stepOneData
            }));
            // console.log("StepOne mounted", commonData.stepOneData);
        } else if (commonData) {
            const { numero_dossier, statut, vendeur_id } = commonData;
            setFormData(prevState => ({
                ...prevState,
                numero_dossier,
                statut,
                vendeur_id
            }));
            // console.log("StepOne mounted", commonData.stepOneData);
        } 
    }, [commonData?.stepOneData, commonData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
        const numericOnlyFields = ['occ_veh_30', 'occ_veh_31', 'veh_19'];
        
        if (name === 'occ_veh_0') {
            let newValue = '';
            
            for (let i = 0; i < Math.min(value.length, 11); i++) {
                const char = value[i];
                newValue += char.toUpperCase();
            }
            
            setFormData({
                ...formData,
                [name]: newValue
            });
            return;
        }
        else if (numericOnlyFields.includes(name)) {
            const numericValue = value.replace(/[^0-9]/g, '');
            setFormData({
                ...formData,
                [name]: numericValue
            });
            return;
        }
        else {
            setFormData({
                ...formData,
                [name]: value.toUpperCase()
            });
        }
    };

    const handleRadioChange = (name, value) => {
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleDateFieldChange = (e, fieldPrefix, part) => {
        const { value } = e.target;
        let newValue = value.replace(/[^0-9]/g, '');
        
        if (part === '1') { // Day
            // Only allow 01-31
            if (newValue.length > 2) newValue = newValue.slice(0, 2);
            if (newValue && parseInt(newValue) > 31) newValue = '31';
            if (newValue && parseInt(newValue) < 1 && newValue.length === 2) newValue = '01';
            // Only add leading zero when field loses focus or has 2 digits
            if (newValue.length === 1 && e.type === 'blur') {
                newValue = '0' + newValue;
            }
        } else if (part === '2') { // Month
            // Only allow 01-12
            if (newValue.length > 2) newValue = newValue.slice(0, 2);
            if (newValue && parseInt(newValue) > 12) newValue = '12';
            if (newValue && parseInt(newValue) < 1 && newValue.length === 2) newValue = '01';
            // Only add leading zero when field loses focus or has 2 digits
            if (newValue.length === 1 && e.type === 'blur') {
                newValue = '0' + newValue;
            }
        } else if (part === '3') { // Year
            // Only allow 4 digit years
            newValue = newValue.slice(0, 4);
            // Ensure year is not in the future
            const currentYear = new Date().getFullYear();
            if (newValue && parseInt(newValue) > currentYear && newValue.length === 4) 
                newValue = currentYear.toString();
        }
        
        setFormData({
            ...formData,
            [`${fieldPrefix}_${part}`]: newValue
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        sendData(formData);
        if (onNext) onNext();
    };

    if (!isActive) return null;

    return (
        <>
            <div className="section">
                <h3>MOTIF DE LA DEMANDE</h3>
                <div className="form-group">
                    <label htmlFor="occ_ra_1">SÉLECTIONNER LA RAISON CORRESPONDANTE:</label>
                    <select
                        id="occ_ra_1"
                        name="occ_ra_1"
                        value={formData.occ_ra_1 || ''}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="">Sélectionner une raison</option>
                        <option value="7">Carte Grise</option>
                        <option value="1">Certificat</option>
                        <option value="2">Duplicata</option>
                        <option value="3">Correction</option>
                        <option value="4">Changement de domicile</option>
                        <option value="5">Changement d&apos;état civil ou matrimonial</option>
                        <option value="6">Changement de caractéristiques techniques</option>
                    </select>
                </div>
            </div>
    
            <div className="section">
                <h3>IDENTIFICATION DU VÉHICULE</h3>
                
                <div className="form-group">
                    <label>DATE D&apos;ACHAT, LE CAS ÉCHÉANT:</label>
                    <div className="date-input-group">
                        <div className="date-field">
                            <label htmlFor="occ_veh_27_1">JOUR</label>
                            <input
                                type="text"
                                id="occ_veh_27_1"
                                name="occ_veh_27_1"
                                value={formData.occ_veh_27_1 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'occ_veh_27', '1')}
                                onBlur={(e) => handleDateFieldChange(e, 'occ_veh_27', '1')}
                                placeholder="JJ"
                                maxLength="2"
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="occ_veh_27_2">MOIS</label>
                            <input
                                type="text"
                                id="occ_veh_27_2"
                                name="occ_veh_27_2"
                                value={formData.occ_veh_27_2 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'occ_veh_27', '2')}
                                onBlur={(e) => handleDateFieldChange(e, 'occ_veh_27', '2')}
                                placeholder="MM"
                                maxLength="2"
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="occ_veh_27_3">ANNÉE</label>
                            <input
                                type="text"
                                id="occ_veh_27_3"
                                name="occ_veh_27_3"
                                value={formData.occ_veh_27_3 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'occ_veh_27', '3')}
                                onBlur={(e) => handleDateFieldChange(e, 'occ_veh_27', '3')}
                                placeholder="AAAA"
                                maxLength="4"
                            />
                        </div>
                    </div>
                </div>
                
                <div className="form-group">
                    <label>DATE DE CERTIFICAT ACTUEL (I):</label>
                    <div className="date-input-group">
                        <div className="date-field">
                            <label htmlFor="occ_veh_28_1">JOUR</label>
                            <input
                                type="text"
                                id="occ_veh_28_1"
                                name="occ_veh_28_1"
                                value={formData.occ_veh_28_1 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'occ_veh_28', '1')}
                                onBlur={(e) => handleDateFieldChange(e, 'occ_veh_28', '1')}
                                placeholder="JJ"
                                maxLength="2"
                                required
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="occ_veh_28_2">MOIS</label>
                            <input
                                type="text"
                                id="occ_veh_28_2"
                                name="occ_veh_28_2"
                                value={formData.occ_veh_28_2 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'occ_veh_28', '2')}
                                onBlur={(e) => handleDateFieldChange(e, 'occ_veh_28', '2')}
                                placeholder="MM"
                                maxLength="2"
                                required
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="occ_veh_28_3">ANNÉE</label>
                            <input
                                type="text"
                                id="occ_veh_28_3"
                                name="occ_veh_28_3"
                                value={formData.occ_veh_28_3 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'occ_veh_28', '3')}
                                onBlur={(e) => handleDateFieldChange(e, 'occ_veh_28', '3')}
                                placeholder="AAAA"
                                maxLength="4"
                                required
                            />
                        </div>
                    </div>
                </div>
                
                <div className="form-group">
                    <label>DATE DE 1ÈRE IMMATRICULATION (B):</label>
                    <div className="date-input-group">
                        <div className="date-field">
                            <label htmlFor="occ_veh_29_1">JOUR</label>
                            <input
                                type="text"
                                id="occ_veh_29_1"
                                name="occ_veh_29_1"
                                value={formData.occ_veh_29_1 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'occ_veh_29', '1')}
                                onBlur={(e) => handleDateFieldChange(e, 'occ_veh_29', '1')}
                                placeholder="JJ"
                                maxLength="2"
                                required
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="occ_veh_29_2">MOIS</label>
                            <input
                                type="text"
                                id="occ_veh_29_2"
                                name="occ_veh_29_2"
                                value={formData.occ_veh_29_2 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'occ_veh_29', '2')}
                                onBlur={(e) => handleDateFieldChange(e, 'occ_veh_29', '2')}
                                placeholder="MM"
                                maxLength="2"
                                required
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="occ_veh_29_3">ANNÉE</label>
                            <input
                                type="text"
                                id="occ_veh_29_3"
                                name="occ_veh_29_3"
                                value={formData.occ_veh_29_3 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'occ_veh_29', '3')}
                                placeholder="AAAA"
                                maxLength="4"
                                required
                            />
                        </div>
                    </div>
                </div>
                
                <div className="form-group">
                    <label htmlFor="occ_veh_0">N° DE FORMULE DU CERTIFICAT D&apos;IMMATRICULATION:</label>
                    <input
                        type="text"
                        id="occ_veh_0"
                        name="occ_veh_0"
                        value={formData.occ_veh_0 || ''}
                        onChange={handleInputChange}
                        placeholder="0000AA00000"
                        pattern="[0-9]{4}[A-Z]{2}[0-9]{5}"
                        maxLength="11"
                        required
                    />
                    <small>Format: 4 chiffres + 2 lettres + 5 chiffres (ex: 0000AA00000)</small>
                </div>
                
                <div className="form-group">
                    <label htmlFor="veh_1">MARQUE (D.1):</label>
                    <input
                        type="text"
                        id="veh_1"
                        name="veh_1"
                        value={formData.veh_1 || ''}
                        onChange={handleInputChange}
                        maxLength="30"
                        required
                    />
                </div>
                
                <div className="form-group">
                    <label htmlFor="veh_2">TYPE, VARIANTE, VERSION (D.2):</label>
                    <input
                        type="text"
                        id="veh_2"
                        name="veh_2"
                        value={formData.veh_2 || ''}
                        onChange={handleInputChange}
                        maxLength="30"
                        required
                    />
                </div>
                
                <div className="form-group">
                    <label htmlFor="veh_4">DÉNOMINATION COMMERCIALE (D.3):</label>
                    <input
                        type="text"
                        id="veh_4"
                        name="veh_4"
                        value={formData.veh_4 || ''}
                        onChange={handleInputChange}
                        maxLength="30"
                    />
                </div>
                
                <div className="form-group">
                    <label htmlFor="veh_6">N° IDENTIFICATION DU VÉHICULE (E):</label>
                    <input
                        type="text"
                        id="veh_6"
                        name="veh_6"
                        value={formData.veh_6 || ''}
                        onChange={handleInputChange}
                        pattern="[A-HJ-NPR-Z0-9]{17}"
                        maxLength="17"
                        required
                    />
                    <small>Format: 17 caractères alphanumériques (sans I, O, Q)</small>
                </div>
                
                <div className="form-group">
                    <label htmlFor="veh_13">GENRE NATIONAL (J.1):</label>
                    <input
                        type="text"
                        id="veh_13"
                        name="veh_13"
                        value={formData.veh_13 || ''}
                        onChange={handleInputChange}
                        maxLength="20"
                        required
                    />
                </div>
                
                <div className="form-group">
                    <label htmlFor="occ_veh_30">N° D&apos;EXPLOITATION AGRICOLE, LE CAS ÉCHÉANT:</label>
                    <input
                        type="text"
                        id="occ_veh_30"
                        name="occ_veh_30"
                        value={formData.occ_veh_30 || ''}
                        onChange={handleInputChange}
                        pattern="[0-9]{10}"
                        maxLength="10"
                    />
                    <small>Format: 10 chiffres</small>
                </div>
                
                <div className="form-group">
                    <label htmlFor="occ_veh_31">KILOMÉTRAGE INSCRIT AU COMPTEUR DU VÉHICULE:</label>
                    <input
                        type="tel" 
                        inputMode="numeric"
                        id="occ_veh_31"
                        name="occ_veh_31"
                        value={formData.occ_veh_31 || ''}
                        onChange={handleInputChange}
                        pattern="[0-9]*"
                        maxLength="7"
                        required
                    />
                    <small>Valeur en kilomètres (chiffres uniquement)</small>
                </div>

                <div className="form-group">
                    <label htmlFor="veh_19">PUISSANCE ADMINISTRATIVE NATIONALE (P.6):</label>
                    <input
                        type="number"
                        id="veh_19"
                        name="veh_19"
                        value={formData.veh_19 || ""}
                        onChange={handleInputChange}
                        min="1"
                        max="100"
                        step="1"
                        title="Veuillez saisir une puissance administrative (nombre entier)"
                    />
                </div>
                
                <div className="radio-group">
                    <label>PRÉSENCE DU CERTIFICAT D&apos;IMMATRICULATION:</label>
                    <div className='radio-group-child'>
                        <div>
                            <input
                                type="radio"
                                id="occ_veh_32_oui"
                                name="occ_veh_32"
                                value="1"
                                checked={formData.occ_veh_32 === '1'}
                                onChange={() => handleRadioChange('occ_veh_32', '1')}
                                required
                            />
                            <label htmlFor="occ_veh_32_oui">OUI</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="occ_veh_32_non"
                                name="occ_veh_32"
                                value="0"
                                checked={formData.occ_veh_32 === '0'}
                                onChange={() => handleRadioChange('occ_veh_32', '0')}
                            />
                            <label htmlFor="occ_veh_32_non">NON</label>
                        </div>
                    </div>
                </div>
                
                {/* Show if certificate is present - Changed to dropdown select */}
                {formData.occ_veh_32 === '1' && (
                    <div className="form-group">
                        <label htmlFor="occ_veh_32_1">QUEL EST LE FORMAT DE VOTRE N° D&apos;IMMATRICULATION?</label>
                        <select
                            id="occ_veh_32_1"
                            name="occ_veh_32_1"
                            value={formData.occ_veh_32_1 || ''}
                            onChange={handleInputChange}
                            required={formData.occ_veh_32 === '1'}
                        >
                            <option value="">Sélectionner un format</option>
                            <option value="1">AB-123-CD</option>
                            <option value="2">123-AB-45</option>
                        </select>
                    </div>
                )}
                
                {/* Show if certificate is not present */}
                {formData.occ_veh_32 === '0' && (
                    <div className="form-group">
                        <label htmlFor="occ_veh_32_2">MOTIF D&apos;ABSENCE DE CERTIFICAT D&apos;IMMATRICULATION:</label>
                        <textarea
                            id="occ_veh_32_2"
                            name="occ_veh_32_2"
                            value={formData.occ_veh_32_2 || ''}
                            onChange={handleInputChange}
                            maxLength="100"
                            rows="3"
                            required={formData.occ_veh_32 === '0'}
                        ></textarea>
                        <small>100 caractères maximum</small>
                    </div>
                )}
               
                {formData.occ_veh_32_1 === '1' && (
                    <div className="form-group">
                        <label htmlFor="occ_veh_27">N° D&apos;IMMATRICULATION DU VÉHICULE (A):</label>
                        <input
                            type="text"
                            id="occ_veh_27"
                            name="occ_veh_27"
                            value={formData.occ_veh_27 || ''}
                            onChange={handleInputChange}
                            pattern="[A-Z]{2}-[0-9]{3}-[A-Z]{2}"
                            maxLength="9"
                            required
                        />
                        <small>Format: AB123CD</small>
                    </div>
                )}

                {formData.occ_veh_32_1 === '2' && (
                    <div className="form-group">
                        <label htmlFor="occ_veh_27">N° D&apos;IMMATRICULATION DU VÉHICULE (A):</label>
                        <input
                        type="text"
                        id="occ_veh_27"
                        name="occ_veh_27"
                        value={formData.occ_veh_27 || ''}
                        onChange={handleInputChange}
                        pattern="[0-9]{3}-[A-Z]{2}-[0-9]{2}"
                        maxLength="9"
                        required
                        />
                        <small>Format: 123-AB-45</small>
                    </div>
                )}
            </div>
            
    
            <div className="section">
                <h3>NUANCE ET COULEUR DOMINANTE</h3>
                <div className="radio-group">
                    <label>NUANCE:</label>
                    <div className='radio-group-child'>
                        <div>
                            <input
                                type="radio"
                                id="veh_33_clair"
                                name="veh_33"
                                value="0"
                                checked={formData.veh_33 === '0'}
                                onChange={() => handleRadioChange('veh_33', '0')}
                                required
                            />
                            <label htmlFor="veh_33_clair">CLAIR</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_33_fonce"
                                name="veh_33"
                                value="1"
                                checked={formData.veh_33 === '1'}
                                onChange={() => handleRadioChange('veh_33', '1')}
                            />
                            <label htmlFor="veh_33_fonce">FONCÉ</label>
                        </div>
                    </div>
                </div>
    
                <div className="radio-group">
                    <label>COULEUR DOMINANTE:</label>
                    <div className='radio-group-child'>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_noir"
                                name="veh_34"
                                value="0"
                                checked={formData.veh_34 === '0'}
                                onChange={() => handleRadioChange('veh_34', '0')}
                                required
                            />
                            <label htmlFor="veh_34_noir">NOIR</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_marron"
                                name="veh_34"
                                value="1"
                                checked={formData.veh_34 === '1'}
                                onChange={() => handleRadioChange('veh_34', '1')}
                            />
                            <label htmlFor="veh_34_marron">MARRON</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_bleu"
                                name="veh_34"
                                value="2"
                                checked={formData.veh_34 === '2'}
                                onChange={() => handleRadioChange('veh_34', '2')}
                            />
                            <label htmlFor="veh_34_bleu">BLEU</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_rouge"
                                name="veh_34"
                                value="3"
                                checked={formData.veh_34 === '3'}
                                onChange={() => handleRadioChange('veh_34', '3')}
                            />
                            <label htmlFor="veh_34_rouge">ROUGE</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_beige"
                                name="veh_34"
                                value="4"
                                checked={formData.veh_34 === '4'}
                                onChange={() => handleRadioChange('veh_34', '4')}
                            />
                            <label htmlFor="veh_34_beige">BEIGE</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_orange"
                                name="veh_34"
                                value="5"
                                checked={formData.veh_34 === '5'}
                                onChange={() => handleRadioChange('veh_34', '5')}
                            />
                            <label htmlFor="veh_34_orange">ORANGE</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_gris"
                                name="veh_34"
                                value="6"
                                checked={formData.veh_34 === '6'}
                                onChange={() => handleRadioChange('veh_34', '6')}
                            />
                            <label htmlFor="veh_34_gris">GRIS</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_jaune"
                                name="veh_34"
                                value="7"
                                checked={formData.veh_34 === '7'}
                                onChange={() => handleRadioChange('veh_34', '7')}
                            />
                            <label htmlFor="veh_34_jaune">JAUNE</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_vert"
                                name="veh_34"
                                value="8"
                                checked={formData.veh_34 === '8'}
                                onChange={() => handleRadioChange('veh_34', '8')}
                            />
                            <label htmlFor="veh_34_vert">VERT</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_blanc"
                                name="veh_34"
                                value="9"
                                checked={formData.veh_34 === '9'}
                                onChange={() => handleRadioChange('veh_34', '9')}
                            />
                            <label htmlFor="veh_34_blanc">BLANC</label>
                        </div>
                    </div>
                </div>
            </div>
    
            <div className="button-container">
                <div></div>
                <button type="button" className="save-button" onClick={() => handleSave(formData)}>ENREGISTRER</button>
                <button type="button" className="next-button" onClick={handleSubmit}>SUIVANT</button>
                
            </div>
        </>
    );
};

StepOneOccasion.propTypes = {
    sendData: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    onNext: PropTypes.func,
    commonData: PropTypes.object,
    handleSave: PropTypes.func.isRequired,
};

export default StepOneOccasion;